import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  useColorMode,
} from '@chakra-ui/react';
import { NavbarWithCallToAction } from '../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction';
import { FooterWithFourColumns } from '../components/chakra/FooterWithFourColumns/FooterWithFourColumns';
import { getColor } from '../brandConfig';

export const WhitePaperPage = () => {
  const { colorMode } = useColorMode();

  return (
    <>
      <NavbarWithCallToAction />
      <Box
        minH="100vh"
        bg={getColor('background.main', colorMode)}
        color={getColor('text.primary', colorMode)}
        position="relative"
      >
        <Container maxW="container.xl" py={20}>
          <VStack spacing={8} textAlign="center" mb={20}>
            <Text
              sx={{
                color: getColor('primary', colorMode),
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                backgroundColor: `${getColor('primary', colorMode)}20`,
                borderRadius: '50em',
                padding: '0.7em 1.3em',
                fontSize: '0.75em',
                fontWeight: 500,
                boxShadow: `0 4px 20px ${getColor('primary', colorMode)}50`,
              }}
            >
              White Paper
            </Text>
            <Heading
              size="2xl"
              color={getColor('text.primary', colorMode)}
            >
              Block52 Technical White Paper
            </Heading>
            <Text
              fontSize="xl"
              color={getColor('text.secondary', colorMode)}
              maxW="2xl"
            >
              Deep dive into the Poker Virtual Machine (PVM) architecture and Block52 infrastructure
            </Text>
          </VStack>

          <Box
            p={{ base: 8, md: 12 }}
            borderRadius="xl"
            border="2px dashed"
            borderColor={getColor('border.medium', colorMode)}
            bg={colorMode === 'dark' ? 'rgba(31, 41, 55, 0.3)' : 'gray.50'}
            textAlign="center"
          >
            <VStack spacing={6}>
              <Text
                fontSize="6xl"
                color={getColor('text.secondary', colorMode)}
                opacity={0.3}
              >
                📄
              </Text>
              <Heading
                size="lg"
                color={getColor('text.primary', colorMode)}
              >
                White Paper Coming Soon
              </Heading>
              <Text
                fontSize="lg"
                color={getColor('text.secondary', colorMode)}
                maxW="2xl"
              >
                We're currently finalizing our technical white paper that details the Poker Virtual Machine architecture,
                tokenomics, validator network, and complete infrastructure specifications.
              </Text>
              <Text
                fontSize="md"
                color={getColor('text.secondary', colorMode)}
                fontStyle="italic"
              >
                Expected Release: Q1 2025
              </Text>
              <Button
                mt={4}
                bg={getColor('primary', colorMode)}
                color="white"
                _hover={{
                  bg: getColor('primaryHover', colorMode),
                  transform: 'translateY(-2px)',
                }}
                onClick={() => window.location.href = '/updates'}
              >
                Get Notified When Published
              </Button>
            </VStack>
          </Box>
        </Container>
      </Box>
      <FooterWithFourColumns />
    </>
  );
};

export default WhitePaperPage;
